module.exports = __webpack_public_path__ + "img/bgHero.35c0193e.jpg";